import React from "react"
import { RichText } from "../RichText/RichText"
import * as styles from "./tableComponent.module.scss"

const TableComponent = ({ noticeData }) => {
  const { title, tableHeadingLeft, tableHeadingRight, tableContent } =
    noticeData
  return (
    <table className={styles.privacyNoticeTable}>
      <tr>
        <th className={`${styles.tableHeadingLeft} ${styles.tableMainHeading}`}>
          {tableHeadingLeft}
        </th>
        <th
          className={`${styles.tableHeadingRight} ${styles.tableMainHeading}`}
        >
          {tableHeadingRight}
        </th>
      </tr>
      {tableContent.map((content: any, idx: number) => {
        const { title, answers } = content
        return (
          <tr>
            <td className={styles.tableHeadingLeft}>{title}</td>
            <td className={styles.tableHeadingRight}>
              <RichText content={answers} />
            </td>
          </tr>
        )
      })}
    </table>
  )
}

export default TableComponent
